import { baseURL } from "../Config";
import axios from "axios";
import { toast } from "react-toastify";
import { trimData } from "../utilities/TrimPayloadData";

export const handlePostRequest = async (data, url) => {
  if (!navigator.onLine) {
    // Handle the case when the network is off
    toast.error(
      "No internet connection. Please check your network and try again."
    );
    return;
  }
  const id = toast.loading("Please wait...");
  //  data = await trimData(data);

  try {
    const response = await axios({
      method: "post",
      url: `${baseURL + url}`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
      },
    });
    toast.update(id, {
      render: response.data.messages,
      type: "success",
      isLoading: false,
      autoClose: 3000,
    });
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 500)
      toast.update(id, {
        render: error?.response?.data?.messages || "Something went wrong !!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    else if (error?.response?.status === 400)
      toast.update(id, {
        render:
          error?.response?.data?.[0]?.toastError || "Something went wrong !!",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    else
      toast.update(id, {
        render: error?.response?.data?.messages || "Something went wrong !!",
        type: "warn",
        isLoading: false,
        autoClose: 3000,
      });
    throw error;
  }
};
